import Reveal from "@/components/7fcc/Reveal";
import FAQAccordion from "@/components/7fcc/FAQAccordion";
import { FAQ } from "@/data/content";

export default function FaqSection() {
  return (
    <section className="bg-ink-950 px-6 py-16 md:py-24" data-testid="faq-section">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <h2
            className="text-center font-display text-3xl font-semibold leading-[1.08] text-fg md:text-5xl"
            data-testid="faq-heading"
          >
            {FAQ.heading}
          </h2>
        </Reveal>
        <Reveal delay={0.12} className="mt-12">
          <FAQAccordion items={FAQ.items} />
        </Reveal>
      </div>
    </section>
  );
}
